// extracted by mini-css-extract-plugin
export default {"menu":"navbar_menu__OAnHT","link":"navbar_link__a-zRf"};